import React, { Component } from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"

/* Accordion Component */
class ExpandableArea extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isExpanded: props.initialStateExpanded,
      height: 0
    }

    this.toggleExpanded = this.toggleExpanded.bind(this)
    this.setClientHeight = this.setClientHeight.bind(this)
    this.renderArea = this.renderArea.bind(this)
    this.isExpanded = this.isExpanded.bind(this)
  }

  componentDidMount() {
    this.setClientHeight()
    window.addEventListener("resize", this.setClientHeight)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setClientHeight)
  }

  setClientHeight() {
    if (!this.contentElement) return
    this.setState({ height: this.contentElement.clientHeight })
  }

  toggleExpanded() {
    this.setState({ isExpanded: !this.state.isExpanded }, this.setClientHeight)
    if (this.props.onToggle) {
      this.props.onToggle()
    }
  }

  isExpanded() {
    const { isExpanded } = this.props
    return typeof isExpanded !== "undefined" ? isExpanded : this.state.isExpanded
  }

  renderArea({ children }) {
    const isExpanded = this.isExpanded()
    return (
      <div style={
        !(isExpanded && this.state.height === 0) ?
          styles.wrapper(
            this.state.height,
            isExpanded
          ) : {}}>
        <div
          ref={element => {
            this.contentElement = element
          }}>
          {children}
        </div>
      </div>
    )
  }

  render() {
    return this.props.children({
      RenderArea: this.renderArea,
      isExpanded: this.isExpanded(),
      toggleExpanded: this.toggleExpanded
    })
  }
}

ExpandableArea.propTypes = {
  initialStateExpanded: PropTypes.bool,
  children: PropTypes.func.isRequired,
  onToggle: PropTypes.func,
  isExpanded: PropTypes.bool
}

ExpandableArea.defaultProps = {
  initialStateExpanded: false
}

export default Radium(ExpandableArea)

const animationDuration = (height, speed) => {
  const calculated = height / 100 / speed
  if (calculated > 0.666 && calculated < 1.5) return calculated
  return calculated > 1.5 ? 1.5 : 0.666
}

const styles = {
  wrapper: (height, open) => ({
    transition: `
      opacity ${animationDuration(height, 10)}s,
      height ${animationDuration(height, 10)}s
    `,
    height: open ? height : "0px",
    opacity: open ? 1 : 0,
    overflow: "hidden"
  })
}



// WEBPACK FOOTER //
// ./src/components/expandable-area/index.jsx